import { getTestsOrBundles } from "../selected-tests-tab-pane";

export function getOrderItemList(data) {
  // let selectedTestList = data.selectedTestList;
  // let bfsTestList = data.bfsTestList;
  // let selectedVwTestPrice = data.selectedVwTestPrice;
  // let selectedDiscountPanelList = data.selectedDiscountPanelList;
  // let selectedCustomPanelList = data.selectedCustomPanelList;
  // let selectedMultiChoosePanelList = data.selectedMultiChoosePanelList;
  // let selectedSeasonalPromoList = data.selectedSeasonalPromoList;
  // let testList = data.testLis;
  // let bundleList = data.bundleList;
  let {
    editOrderItemList,
    paymentMethod, isMarkupEligible, selectedItemList, selectedMerchList,
    testNodeList, bundleList
  } = data;

  let orderItemList = [];
  // handle shortcuts
  let shortcutTests = [];
  let shortcutDiscountPanels = [];
  let shortcutCustomPanels = [];
  let shortcutXChooseYPanels = [];
  selectedItemList.filter(item => item.category === "shortcut").forEach(shortcut => {
    let { testIdList, discountPanelIdList, customPanelIdList, selectedXChooseYPanelList } = shortcut;
    let tests = data.testList.filter(test => testIdList.includes(test.id))
      ?.map(test => {
        return { ...test, shortcutId: shortcut.id }
      });
    shortcutTests = shortcutTests.concat(tests);
    let discountPanels = data.bundleList
      .filter(bundle => discountPanelIdList.includes(bundle.bundleId))
      ?.map(bundle => {
        return { ...bundle, shortcutId: shortcut.id }
      });
    shortcutDiscountPanels = shortcutDiscountPanels.concat(discountPanels);
    let customPanels = data.bundleList
      .filter(bundle => customPanelIdList.includes(bundle.bundleId))
      ?.map(bundle => {
        return { ...bundle, shortcutId: shortcut.id }
      });
    shortcutCustomPanels = shortcutCustomPanels.concat(customPanels);
    if (selectedXChooseYPanelList) {
      let xChooseYs = selectedXChooseYPanelList.filter(xChooseY => !xChooseY.customPanelId)
        ?.map(xChooseY => {
          return { ...xChooseY, shortcutId: shortcut.id }
        });
      shortcutXChooseYPanels = shortcutXChooseYPanels.concat(xChooseYs);
    }
    // add a shortcut obj for each shortcut
    let markupForBackend = getMarkupForBackend(shortcut, paymentMethod, isMarkupEligible);
    orderItemList.push({
      item_id: shortcut.id,
      item_name: shortcut.shortcutName,
      item_type: "shortcutId",
      original_price: "0.00",
      total: "0.00",
      markup: markupForBackend.markupPrice,
      markup_version: markupForBackend.markupVersion,
      customized_name: markupForBackend.customizedName
    });
  });
  // va or vw tests
  selectedItemList.filter(item => ["va", "vw"].includes(item.category))
    .concat(shortcutTests).forEach(test => {
      let markupForBackend = getMarkupForBackend(test, paymentMethod, isMarkupEligible);
      if (isNaN(test.id)) {
        // duplicate test, change string id to corresponding int id
        let [itemId, packageId] = test.id.split("_");
        orderItemList.push({
          item_id: Number(itemId),
          item_type: "packagePriceId",
          original_price: test.originalPrice.toString(),
          total: test.price.toString(),
          package_id: Number(packageId),
          shortcut_id: test.shortcutId ? test.shortcutId : null,
          markup: markupForBackend.markupPrice,
          markup_version: markupForBackend.markupVersion,
          customized_name: markupForBackend.customizedName,
        });
      }
      else {
        if (test.id < 0) {
          // selected test is a fake test created in frontend
          // send true tests included in this fake test to backend
          let currentTestNode = data.testNodeList.find(node => node.id === test.id);
          currentTestNode.descendants.forEach(d => {
            orderItemList.push({
              item_id: d.id,
              item_type: "packagePriceId",
              original_price: d.value.originalPrice.toString(),
              total: d.value.price.toString(),
              package_id: null,
              shortcut_id: currentTestNode.shortcutId ? currentTestNode.shortcutId : null,
              markup: markupForBackend.markupPrice,
              markup_version: markupForBackend.markupVersion,
              customized_name: markupForBackend.customizedName,
            });
          })
        }
        else {
          orderItemList.push({
            item_id: test.id,
            item_type: "packagePriceId",
            original_price: test.originalPrice.toString(),
            total: test.price.toString(),
            package_id: null,
            shortcut_id: test.shortcutId ? test.shortcutId : null,
            markup: markupForBackend.markupPrice,
            markup_version: markupForBackend.markupVersion,
            customized_name: markupForBackend.customizedName,
          });
        }
      }
    });

  // discount panel
  selectedItemList.filter(item => item.category === "discountPanel")
    .concat(shortcutDiscountPanels).forEach(panel => {
      let markupForBackend = getMarkupForBackend(panel, paymentMethod, isMarkupEligible);
      orderItemList.push({
        item_id: panel.bundleId,
        item_type: "bundleId",
        original_price: panel.originalPrice.toString(),
        total: panel.price.toString(),
        shortcut_id: panel.shortcutId ? panel.shortcutId : null,
        markup: markupForBackend.markupPrice,
        markup_version: markupForBackend.markupVersion,
        customized_name: markupForBackend.customizedName,
      });
    });

  // custom panel
  selectedItemList.filter(item => item.category === "customPanel")
    .concat(shortcutCustomPanels).forEach(panel => {
      let markupForBackend = getMarkupForBackend(panel, paymentMethod, isMarkupEligible);
      let orderedCustomPanel = {
        item_id: panel.bundleId,
        item_type: "bundleId",
        original_price: panel.originalPrice.toString(),
        total: panel.price.toString(),
        shortcut_id: panel.shortcutId ? panel.shortcutId : null,
        markup: markupForBackend.markupPrice,
        markup_version: markupForBackend.markupVersion,
        customized_name: markupForBackend.customizedName,
      };
      if (panel.selectedXChooseYPanelList) {
        let supplementList = [];
        let xChooseYList = []
        panel.selectedXChooseYPanelList.forEach(xChooseY => {
          if (xChooseY) {
            return;
          }
          supplementList.push({
            itemId: panel.bundleId,
            itemType: "bundleId",
            chosen_quantity: xChooseY.supplementQuantity,
            promotion_coupon_id: xChooseY.promotion_coupon_id,
            x_choose_y_detail_list: xChooseY.selectedSupplementIdList
              ? xChooseY.selectedSupplementIdList.map(id => {
                return { item_id: id, item_type: "packagePriceId" }
              })
              : []
          });
          xChooseYList.push({
            chosen_quantity: xChooseY.quantity,
            itemId: panel.bundleId,
            itemType: "bundleId",
            promotion_coupon_id: xChooseY.promotion_coupon_id,
            x_choose_y_detail_list: (xChooseY.selectedZoomerIdList || []).map(id => {
              return { item_id: id, item_type: "packagePriceId" }
            })
          });
        });
        orderedCustomPanel.supplement_x_choose_y_List = supplementList;
        orderedCustomPanel.x_choose_y_List = xChooseYList;
      }
      orderItemList.push(orderedCustomPanel);

    });

  // xChooseY panel
  selectedItemList.filter(item => item.category === "xChooseY")
    .concat(shortcutXChooseYPanels).forEach(panel => {
      let markupForBackend = getMarkupForBackend(panel, paymentMethod, isMarkupEligible);
      let testsInPanel = getTestsOrBundles(panel, testNodeList, bundleList);
      let originalPrice = testsInPanel.map(item => item.originalPrice).reduce((pre, cur) => pre + cur, 0);
      orderItemList.push({
        item_id: panel.bundleId,
        item_type: "bundleId",
        original_price: originalPrice.toFixed(2),
        shortcut_id: panel.shortcutId ? panel.shortcutId : null,
        supplement_x_choose_y_List: [{
          itemId: panel.bundleId,
          itemType: "bundleId",
          chosen_quantity: panel.supplementQuantity,
          promotion_coupon_id: panel.promotion_coupon_id,
          x_choose_y_detail_list: panel.selectedSupplementIdList
            ? panel.selectedSupplementIdList.map(id => {
              return { item_id: id, item_type: "packagePriceId" }
            })
            : []
        }],
        total: panel.price.toString(),
        x_choose_y_List: [{
          chosen_quantity: panel.quantity,
          itemId: panel.bundleId,
          itemType: "bundleId",
          promotion_coupon_id: panel.promotion_coupon_id,
          x_choose_y_detail_list: (panel.selectedZoomerIdList || []).map(id => {
            return { item_id: id, item_type: "packagePriceId" }
          })
        }],
        markup: markupForBackend.markupPrice,
        markup_version: markupForBackend.markupVersion,
        customized_name: markupForBackend.customizedName,
      });
    });

  // seasonal promotion
  selectedItemList.filter(item => item.category === "seasonalPromo").forEach(promo => {
    let markupForBackend = getMarkupForBackend(promo, paymentMethod, isMarkupEligible);
    promo.appliedTests.forEach(testId => {
      let test = data.testList.find(t => t.id === testId || t.originalId === testId);
      if (test) {
        orderItemList.push({
          item_id: testId,
          item_type: "packagePriceId",
          original_price: test.price.toString(),
          total: promo.finalAmount.toString(),
          promotion_coupon_id: promo.id,
          markup: markupForBackend.markupPrice,
          markup_version: markupForBackend.markupVersion,
          customized_name: markupForBackend.customizedName,
        })
      }
    });
    promo.appliedBundles.forEach(bundleId => {
      let bundle = data.bundleList.find(b => b.bundleId === bundleId);
      if (bundle) {
        let markupForBackend = getMarkupForBackend(bundle, paymentMethod, isMarkupEligible);
        orderItemList.push({
          item_id: bundleId,
          item_type: "bundleId",
          original_price: bundle.originalPrice.toString(),
          total: promo.finalAmount.toString(),
          promotion_coupon_id: promo.id,
          markup: markupForBackend.markupPrice,
          markup_version: markupForBackend.markupVersion,
          customized_name: markupForBackend.customizedName,
        })
      }
    });
  });
  // add editOrder original items that are not in selectedItemList, and
  // update price for those items that exist in selectedItemList
  // data.editOrderItemList.forEach(item => {
  //   let existItem = orderItemList.find(i => i.item_id === item.item_id && i.item_type === item.item_type);
  //   if (existItem) {
  //     existItem.total = item.total.toFixed(2);
  //     existItem.original_price = item.original_price.toFixed(2);
  //   } else {
  //     let notIncludedItem = { ...item };
  //     if (notIncludedItem.item_id < 0) { // skip for fake items
  //       return;
  //     }
  //     delete notIncludedItem.category;
  //     orderItemList.push(notIncludedItem);
  //   }
  // });
  let itemListFromEditOrder = getEditOrderItemsForApi([...editOrderItemList], paymentMethod, isMarkupEligible);

  let itemInSelectedMerchList = getMerchItemsForApi(selectedMerchList);
  return orderItemList.concat(itemListFromEditOrder).concat(itemInSelectedMerchList);
}

function getEditOrderItemsForApi(editOrderItemList, paymentMethod, isMarkupEligible) {
  let itemList = [];
  editOrderItemList.forEach(item => {
    if (item.category === "shortcut") {
      itemList.push({
        ...item,
        item_type: "shortcutId",
        original_price: "0.00",
        total: "0.00"
      });
      item.contents.forEach(c => {
        itemList.push({ ...c });
      });
      return;
    }
    if (item.category === "seasonalPromo") {
      item.contents.forEach(c => {
        itemList.push({ ...c });
      })
      return;
    }
    if (item.category === "xChooseY") {
      itemList.push({
        ...item,
        item_type: "bundleId",
        original_price: item.original_price.toString(),
        total: item.total.toString(),
      });
      return;
    }
    itemList.push({ ...item });
  });
  itemList.forEach(item => {
    item.total = item.total.toString();
    item.original_price = item.original_price ? item.original_price.toString() : null;
    let markupForBackend = getMarkupForBackend(item, paymentMethod, isMarkupEligible);
    item.markup = markupForBackend.markupPrice;
    item.markup_version = markupForBackend.markupVersion;
    item.customized_name = markupForBackend.customizedName;
    if (isNaN(item.item_id)) {
      let [itemId, packageId] = item.item_id.split("_");
      item.item_id = Number(itemId);
      item.package_id = Number(packageId);
    }
    // delete fields that backend not need
    delete item.category;
    delete item.sampleTypeSets;
    delete item.isOnMenu;
    delete item.markupPrice;
    delete item.markupVersion;
  })
  return itemList;
}

function getMarkupForBackend(item, paymentMethod, isMarkupEligible) {
  if (!isMarkupEligible || paymentMethod === "customerPay" || item.shortcutId) {
    return { markupPrice: null, markupVersion: null };
  }

  let markupVersion = [0, -1].includes(item.markupVersion) ? 0 : item.markupVersion;

  // const customizedName = item.customizedName ? customizedName : null;
  let customizedName = item.customizedName ? item.customizedName : null;
  return { markupPrice: item.markupPrice ? item.markupPrice.toFixed(2) : null, markupVersion, customizedName };
}

function getMerchItemsForApi(selectedMerchList) {
  return selectedMerchList.map(item => {
    const { id, merch, quantity } = item;
    const currentPrice = merch.currentPrice;
    const original_price = merch.originalPrice * quantity;
    const total = currentPrice * quantity;
    const merchandise_refund_info = merch.return_and_refund_info;

    return {
      item_type: "merchandise",
      item_type_id: id,
      customized_name: merch.name,
      quantity,
      original_price,
      unit_price: parseFloat(currentPrice.toFixed(2)),
      total: parseFloat(total.toFixed(2)),
      merchandise_type: merch.type,
      merchandise_refund_info
    };
  });
}

// ========== V2 Place Order line_items helpers ==========

export function getLineItemsPayalod(data) {
  let {
    editOrderItemList,
    paymentMethod,
    isMarkupEligible,
    selectedItemList,
    selectedMerchList,
    selectedVwTestPrice,
    testNodeList,
    bundleList,
  } = data;
  let lineItems = [];
  selectedItemList.forEach(item => {
    let lineItem = null;
    switch (item.category) {
      case "va":
      case "vw":
        lineItem = getLineItemForTest(item, selectedVwTestPrice);
        break;
      case "discountPanel":
      case "customPanel":
      case "xChooseY":
        lineItem = getLineItemForBundle(item, selectedVwTestPrice, testNodeList);
        break;
      case "shortcut":
        lineItem = getLineItemForShortcut(item, selectedVwTestPrice, testNodeList, bundleList);
        break;
      case "program":
        lineItem = getLineItemForProgram(item);
        break;
      default:
        break;
    }
    if (lineItem) {
      let markupForBackend = getMarkupForBackend(item, paymentMethod, isMarkupEligible);
      let { markupPrice, markupVersion, customizedName } = markupForBackend;
      const normalizedMarkupPrice = Number(markupPrice);
      lineItem.meta_data = {
        ...lineItem.meta_data,
        markup: Number.isFinite(normalizedMarkupPrice)
          ? parseFloat(normalizedMarkupPrice.toFixed(2))
          : null,
        markup_version: markupVersion,
        customized_name: customizedName
      };
      if (lineItem.item_type === "Shortcut") {
        lineItem.sub_items.forEach(subItem => {
          subItem.meta_data.shortcut_id = lineItem.item_id;
          lineItems.push(subItem);
        });
        lineItems.push({
          item_id: lineItem.item_id,
          item_type: lineItem.item_type,
          item_name: lineItem.item_name,
          original_price: 0,
          total: 0,
          meta_data: lineItem.meta_data,
        });
        return;
      }
      lineItems.push(lineItem);
    }
  });
  selectedMerchList.forEach(item => {
    let lineitem = getLineItemForMerchV2(item);
    lineitem && lineItems.push(lineitem);
  });
  return lineItems;
}

function getLineItemForTest(test, selectedVwTestPrice) {
  let testId, parentId;
  if (typeof test.id === "string") {
    [testId, parentId] = test.id.split("_");
    testId = parseInt(testId);
    parentId = parseInt(parentId);
  } else {
    testId = test.id;
    parentId = null;
  }
  let metaData = parentId ? { item_place: parentId } : {};
  return {
    item_id: testId,
    item_type: "TESTGROUP",
    item_name: test.displayName || "",
    original_price: parseFloat(test.originalPrice.toFixed(2)),
    total: test.id === 181 && selectedVwTestPrice > 199 ? 60 : parseFloat(test.price.toFixed(2)),
    meta_data: metaData,
  };
}

function getLineItemForBundle(bundle, selectedVwTestPrice, testNodeList) {
  let bundleTestIds = [];
  let supplementTestIds = [];
  let isXChooseY = bundle.category === "xChooseY" ? true : false;

  if (bundle.category === "discountPanel") {
    // For discount panels, extract test IDs from bundleContent
    if (bundle.bundleContent) {
      let { packageList, testList } = bundle.bundleContent;
      bundleTestIds = (packageList ? packageList.map(p => p.packageId) : [])
        .concat(testList ? testList.map(t => t.testId) : []);
    }
  } else if (bundle.category === "customPanel") {
    // For custom panels, extract test IDs from bundleItemList
    if (bundle.bundleItemList) {
      bundleTestIds = bundle.bundleItemList
        .filter(item => item.itemType !== "official bundle")
        .map(item => item.itemId);
    }
  } else if (!isXChooseY) {
    // For other non-xChooseY bundles, use selectedZoomerIdList/selectedSupplementIdList
    let { selectedZoomerIdList, selectedSupplementIdList } = bundle;
    bundleTestIds = selectedZoomerIdList ? selectedZoomerIdList : [];
    supplementTestIds = selectedSupplementIdList ? selectedSupplementIdList : [];
  } else {
    // For xChooseY bundles, use testIdsInPanel
    bundleTestIds = bundle.testIdsInPanel;
  }

  let subItems = getSubItemsForBundle(bundleTestIds.concat(supplementTestIds), selectedVwTestPrice, testNodeList);
  subItems.filter(item => supplementTestIds.includes(item.item_id)).forEach(item => {
    item.meta_data.is_supplement = true;
  });
  return {
    item_id: bundle.bundleId,
    item_type: "Bundle",
    item_name: bundle.bundleName || "",
    original_price: parseFloat((bundle.originalPrice || 0).toFixed(2)),
    total: parseFloat((bundle.price || 0).toFixed(2)),
    sub_items: subItems,
    meta_data: { is_x_choose_y: isXChooseY }
  };
}

function getLineItemForShortcut(shortcut, selectedVwTestPrice, testNodeList, bundleList) {
  let { testIdList, discountPanelIdList, customPanelIdList, selectedXChooseYPanelList } = shortcut;
  let subItems = getSubItemsForBundle(testIdList, selectedVwTestPrice, testNodeList);
  let shortcutXChoooseYBundles = selectedXChooseYPanelList?.filter(xChooseY => !xChooseY.customPanelId) || [];
  let shortcutBundles = bundleList.filter(b => [...discountPanelIdList, ...customPanelIdList].includes(b.bundleId))
    .concat(shortcutXChoooseYBundles);
  shortcutBundles.forEach(bundle => {
    let lineItem = getLineItemForBundle(bundle, selectedVwTestPrice, testNodeList);
    lineItem && subItems.push(lineItem);
  });
  return {
    item_id: shortcut.id,
    item_type: "Shortcut",
    item_name: shortcut.shortcutName || "",
    original_price: shortcut.price,
    total: shortcut.price,
    sub_items: subItems,
    meta_data: {}
  };
}

function getSubItemsForBundle(bundleTestIds, selectedVwTestPrice, testNodeList) {
  let subItems = [];
  bundleTestIds.forEach(testId => {
    let testNode = testNodeList.find(node => node.id === testId);
    if (testNode) {
      let lineItem = getLineItemForTest(testNode.value, selectedVwTestPrice);
      lineItem && subItems.push(lineItem);
    }
  });
  return subItems;
}

function getLineItemForProgram(program) {
  return {
    item_id: program.program_code,
    item_type: "Program",
    item_name: program.name || program.displayName || "",
    original_price: parseFloat((program.originalPrice || program.price || 0).toFixed(2)),
    total: parseFloat((program.price || 0).toFixed(2)),
    meta_data: {},
  };
}

function getLineItemForMerchV2(merchandise) {
  const { id, merch, quantity } = merchandise;
  const currentPrice = merch.currentPrice;
  const original_price = parseFloat((merch.originalPrice * quantity).toFixed(2));
  const total = parseFloat((currentPrice * quantity).toFixed(2));
  const merchandise_refund_info = merch.return_and_refund_info;
  return {
    item_id: Number(id),
    item_type: "Merchandise",
    item_name: merch.name || "",
    original_price,
    total,
    meta_data: {
      unit_price: parseFloat(currentPrice.toFixed(2)),
      quantity,
      ...merchandise_refund_info
    }
  };
}